import { Button } from '../components/button'
import { defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from './state'
import Section from '../components/section'
import { Spinner } from '../components/spinner'

export default defineComponent({
  name: 'page.stage7',
  setup () {
    const store = useStore()
    const router = useRouter()

    store.initStage(7)

    const state = reactive({
      loading: false,
    })

    const goToNext = async () => {
      if (store.stageValidity !== true) return

      state.loading = true
      const res = await store.submit3()
      state.loading = false

      if (!res.success) {
        return alert('서버 에러! 관리자에게 문의해주세요')
      }

      router.push({ name: 'main' })
    }

    return () => (
      <div class="py-20 mx-auto">
        <Section>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            귀하는 연구 참여 대상자에 해당합니다. 연구 담당자가 연구 참여 방법이
            포함된 자세한 안내를 드리고, 귀하의 연구 참여 의사를 최종적으로
            확인하기 위해 1, 2주 내로 연락을 드리겠습니다.
            <br />
            <br />
            원활한 연락을 위해 앞서 입력해주신 연락처를 다시 한번 확인
            부탁드립니다.
          </div>
        </Section>
        <Section class="items-center">
          <div class="font-bold text-lg basis-20">이메일</div>
          <div class="ml-4 grow">
            <input
              class="border rounded p-4 w-full"
              placeholder="example@gmail.com"
              type="email"
              value={store.email}
              onInput={(e) => {
                store.email = (e.target as HTMLInputElement).value.trim()
              }}
            />
          </div>
        </Section>
        <Section class="items-center">
          <div class="font-bold text-lg basis-20">전화번호</div>
          <div class="ml-4 grow">
            <input
              class="border rounded p-4 w-full"
              placeholder="010-1234-1234"
              type="tel"
              value={store.phone}
              onInput={(e) => {
                store.phone = (e.target as HTMLInputElement).value.trim()
              }}
            />
          </div>
        </Section>
        <Section>
          <Button class="w-full" onClick={goToNext} disabled={state.loading}>
            <div class="flex justify-center items-center">
              <div class="mr-2">
                <Spinner v-show={state.loading} />
              </div>
              <div>확인</div>
            </div>
          </Button>
        </Section>
      </div>
    )
  },
})
